import styled from 'styled-components'

import WarningSvg from '@/assets/svgs/warning-fill.svg?react'
import { Text } from '@/components/Text'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WarningIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 32px 0;
`

export const WarningIcon = styled(WarningSvg)`
  color: ${({ theme }) => theme.colors.common.alert};
  width: 48px;
  height: 48px;
`

export const TextContent = styled.div`
  width: 100%;
`

export const Paragraph = styled(Text)`
  margin-top: 12px;
  margin-bottom: 24px;
`

export const BmiValue = styled(Text)`
  margin-top: 16px;
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 700;
`

export const PhoneLink = styled.a`
  color: ${({ theme }) => theme.colors.primary.main};
  text-decoration: underline;
  font-weight: 600;
`

export const HoursContainer = styled.div`
  margin-top: 12px;
  margin-bottom: 24px;
  border-radius: 8px;
`

export const HoursTitle = styled(Text)`
  font-weight: 600;
  margin-bottom: 8px;
`

export const HoursText = styled(Text)`
  margin-bottom: 4px;
`
